import { render, staticRenderFns } from "./kfqg.vue?vue&type=template&id=348d4c6c&scoped=true&"
import script from "./kfqg.vue?vue&type=script&lang=js&"
export * from "./kfqg.vue?vue&type=script&lang=js&"
import style0 from "./kfqg.vue?vue&type=style&index=0&id=348d4c6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d4c6c",
  null
  
)

export default component.exports